/*eslint-disable*/
import React from "react";
import PropTypes from "prop-types";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import ListItem from "@material-ui/core/ListItem";
import List from "@material-ui/core/List";
import { config } from "Constants";
// core components
import styles from "assets/jss/material-dashboard-react/components/footerStyle.js";

const useStyles = makeStyles(styles);

export default function Footer(props) {
  const classes = useStyles();
  return (
    <footer className={classes.footer}>
      <div className={classes.container}>
        {
        <div className={classes.left}>
          
          <List className={classes.list}>
            <ListItem className={classes.inlineBlock}>
              <a href={`${config.url.FRONTEND}/terms`} className={classes.block}>
                Terms of use
              </a>
            </ListItem>
            <ListItem className={classes.inlineBlock}>
              <a href={`${config.url.FRONTEND}/privacy`} className={classes.block}>
                Privacy and cookies
              </a>
            </ListItem>
          </List>
          
        </div>
         }
        <p className={classes.right}>
          <span>
            &copy; {1900 + new Date().getYear()}{" "}
            <a
              href="https://www.controlthings.fi"
              target="_blank"
              className={classes.a}
            >
              ControlThings Oy Ab
            </a>
            , excellence embedded
          </span>
        </p>
      </div>
    </footer>
  );
}
